import { render, staticRenderFns } from "./DashboardIcon.vue?vue&type=template&id=66706e41&"
import script from "./DashboardIcon.vue?vue&type=script&lang=js&"
export * from "./DashboardIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports